<div class="flex flex-1 w-full h-full justify-center">
    <div class="flex flex-wrap my-4 basis-[90vw]">
        <h1
            class="flex basis-full text-2xl text-white justify-center py-4 h-16"
        >
            Past samples
        </h1>
        <div class="flex grow overflow-hidden rounded-lg bg-white h-[75vh]">
            <zt-history-table
                [data]="history"
                [sortBy]="'requestedAt'"
            ></zt-history-table>
        </div>
    </div>
    <p-dialog
        header="Delete execution"
        [(visible)]="shouldShowDeleteExecutionDialog"
        [closeOnEscape]="false"
        [resizable]="false"
        [draggable]="false"
        [breakpoints]="{ '960px': '45vw', '640px': '100vw' }"
        [style]="{ width: '40vw' }"
        [closable]="false"
    >
        Are you sure you want to delete the selected execution from history?
        This action cannot be undone.
        <ng-template pTemplate="footer">
            <div class="flex gap-4 justify-end">
                <zt-button
                    [config]="cancelBtnConfig"
                    [type]="ZtButtonType.TERTIARY"
                    (onClick)="closeConfirmDeleteDialog()"
                    >Cancel</zt-button
                >
                <zt-button
                    [config]="confirmDeleteBtnConfig"
                    [type]="ZtButtonType.SECONDARY"
                    (onClick)="confirmDeleteDialog()"
                    >Delete</zt-button
                >
            </div>
        </ng-template>
    </p-dialog>
</div>
